import React from 'react';
import { Construction } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { SecondaryNavData, flattenNavData } from '../Constant';

const ComingSoon = ({ title: titleProp, subtitle }) => {
  const { view } = useParams();
  const allNav = [...flattenNavData(), ...SecondaryNavData];
  const match = allNav.find(item => item.path === view);
  const title = titleProp || match?.name || 'Coming soon';

  return (
    <div className="p-8 lg:p-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2 font-serif">{title}</h1>
        {subtitle ? <p className="text-muted">{subtitle}</p> : null}
      </div>

      <div className="flex flex-col items-center justify-center py-24 rounded-xl border border-dashed border-shell-card-border bg-shell-card/40">
        <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
          <Construction className="w-7 h-7 text-primary" />
        </div>
        <p className="text-white font-medium mb-1">{title} is being built</p>
        <p className="text-sm text-muted-dim max-w-md text-center">
          This module will be available in a later redesign phase. Existing APIs are unchanged.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
